import PropTypes from "prop-types"
import { get } from "lodash"
import { CHART_ITEM } from "helpers/shapes"
import "./style.scss"

function getValue(data, index, formatter) {
  const value = get(data, `${index}.value`, undefined)

  if (value === undefined || Number.isNaN(value)) {
    return "N/A"
  } else {
    return formatter(value)
  }
}

function ColorTooltipItem({ index, data, label, color, formatter }) {
  return <div className="components_charts_color-tooltip-item">
    <span className="color" style={{ backgroundColor: color }} />
    <span className="dimension">{label}</span>
    <span className="value">{getValue(data, index, formatter)}</span>
  </div>
}

ColorTooltipItem.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.arrayOf(CHART_ITEM),
  label: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  formatter: PropTypes.func.isRequired,
}

export default ColorTooltipItem
